// @ts-nocheck
import _, { isArray, isUndefined } from "lodash";
import { getMediaType } from "../../utils/constants/getFileType";
import { DEFAULT_ESTIMATE_NAME } from "../../utils/constants/nmaes";
import {
  calcEstimateForPO,
  calcEstimateForCaliforniaPO,
  formatValue,
  isTimeTBD,
  getFinalTerms,
  getObjForPOCalculation,
  isClientAndConPosTermsDiffrent,
  isContractorFieldsAvailable,
  checkValidValue
} from "../../appCalcutions";
import {
  POST_APPLIED_RATE_EVENT_REQUEST_FAILURE,
  POST_APPLIED_RATE_EVENT_REQUEST_REQUEST,
  UPDATE_PO_NUMBER_SUCCESS
} from "../constants/estimate";
import {
  REFRESH_POSITIONS_FAILURE,
  REFRESH_POSITIONS_REQUEST,
  REFRESH_POSITIONS_SUCCESS,
  UPDATE_DEPOSIT_INVOICE_STATUS_FAILURE,
  UPDATE_DEPOSIT_INVOICE_STATUS_REQUEST,
  UPDATE_DEPOSIT_INVOICE_STATUS_SUCCESS
} from "../constants/eventRequest";
import {
  ADD_TIME_DIFFERENCE,
  ASSIGN_CONTRACTOR_FAILURE,
  ASSIGN_CONTRACTOR_REQUEST,
  ASSIGN_CONTRACTOR_SUCCESS,
  ASSIGN_COORDINATOR_FAILURE,
  ASSIGN_COORDINATOR_REQUEST,
  ASSIGN_COORDINATOR_SUCCESS,
  FETCH_EVENT_DETAILS_FAILURE,
  FETCH_EVENT_DETAILS_REQUEST,
  FETCH_EVENT_DETAILS_SUCCESS,
  REMOVE_COORDINATOR_FAILURE,
  REMOVE_COORDINATOR_REQUEST,
  REMOVE_COORDINATOR_SUCCESS,
  REMOVE_POSITION_FAILURE,
  REMOVE_POSITION_REQUEST,
  REMOVE_POSITION_SUCCESS,
  REMOVE_SESSION_FAILURE,
  REMOVE_SESSION_REQUEST,
  REMOVE_SESSION_SUCCESS,
  SUBMIT_ESTIMATE_FAILURE,
  SUBMIT_ESTIMATE_REQUEST,
  SUBMIT_ESTIMATE_SUCCESS,
  UPDATE_SESSION_POSITION_SUCCESS,
  UPDATE_SESSION_POSITION_REQUEST,
  UPDATE_SESSION_POSITION_FAILURE,
  UPDATE_SESSION_REQUEST,
  UPDATE_SESSION_SUCCES,
  UPDATE_SESSION_FAILURE,
  SET_EVENT_INFO,
  TOGGLE_SHOW_CONTRACTOR_INITIALS_REQUEST,
  TOGGLE_SHOW_CONTRACTOR_INITIALS_SUCCESS,
  TOGGLE_SHOW_CONTRACTOR_INITIALS_FAILURE,
  SET_FIELD_FOR_POSITION,
  FETCH_LOGS_REQUEST,
  FETCH_LOGS_SUCCESS,
  FETCH_LOGS_FAILURE,
  CREATE_LOG_REQUEST,
  CREATE_LOG_SUCCESS,
  CREATE_LOG_FAILURE,
  REFRESH_EVENT_REQUEST,
  REFRESH_EVENT_SUCCESS,
  REFRESH_EVENT_FAILURE,
  MARK_EVENT_COMPLETE_REQUEST,
  MARK_EVENT_COMPLETE_SUCCESS,
  MARK_EVENT_COMPLETE_FAILURE,
  FETCH_EVENT_DETAILS_POSITIONS_SUCCESS,
  ADD_NEW_POSITION_REQUEST,
  ADD_NEW_POSITION_SUCCESS,
  ADD_NEW_POSITION_FAILURE,
  FETCH_SCHEDULE_RESOURCES_REQUEST,
  FETCH_SCHEDULE_RESOURCES_SUCCESS,
  FETCH_SCHEDULE_RESOURCES_FAILURE,
  FETCH_CONTENT_RESOURCES_REQUEST,
  FETCH_CONTENT_RESOURCES_SUCCESS,
  FETCH_CONTENT_RESOURCES_FAILURE,
  UPLOAD_SCHEDULE_RESOURCES_REQUEST,
  UPLOAD_SCHEDULE_RESOURCES_SUCCESS,
  UPLOAD_SCHEDULE_RESOURCES_FAILURE,
  UPLOAD_CONTENT_RESOURCES_REQUEST,
  UPLOAD_CONTENT_RESOURCES_SUCCESS,
  UPLOAD_CONTENT_RESOURCES_FAILURE,
  DELETE_SCHEDULE_RESOURCES_REQUEST,
  DELETE_SCHEDULE_RESOURCES_SUCCESS,
  DELETE_SCHEDULE_RESOURCES_FAILURE,
  DELETE_CONTENT_RESOURCES_REQUEST,
  DELETE_CONTENT_RESOURCES_SUCCESS,
  DELETE_CONTENT_RESOURCES_FAILURE,
  DELETE_ALL_CONTENT_FILES_REQUEST,
  DELETE_ALL_CONTENT_FILES_SUCCESS,
  DELETE_ALL_CONTENT_FILES_FAILURE,
  DELETE_ALL_SCHEDULE_FILES_REQUEST,
  DELETE_ALL_SCHEDULE_FILES_SUCCESS,
  DELETE_ALL_SCHEDULE_FILES_FAILURE,
  CHANGE_ASSIGN_BY_REQUEST,
  CHANGE_ASSIGN_BY_SUCCESS,
  CHANGE_ASSIGN_BY_FAILURE,
  APPROVE_TIME_REQUEST,
  APPROVE_TIME_SUCCESS,
  APPROVE_TIME_FAILURE,
  EVENT_DETAILS_TAB_SELECTED_SESSION,
  EVENT_DETAILS_TAB_SELECTED_PAGE,
  EVENT_REPORTED_TAB_SELECTED_SESSION,
  EVENT_REPORTED_TAB_SELECTED_PAGE,
  EVENT_ADD_NOTE_REQUEST,
  EVENT_ADD_NOTE_SUCCESS,
  EVENT_ADD_NOTE_FAILURE,
  FETCH_ASSIGNED_USERS_REQUEST,
  FETCH_ASSIGNED_USERS_SUCCESS,
  FETCH_ASSIGNED_USERS_FAILURE,
  // FETCH_ONE_ON_ONE_NOTES_REQUEST,
  // FETCH_ONE_ON_ONE_NOTES_SUCCESS,
  // FETCH_ONE_ON_ONE_NOTES_FAILURE,
  FETCH_ONE_ON_ONE_ROOMS_REQUEST,
  FETCH_ONE_ON_ONE_ROOMS_SUCCESS,
  FETCH_ONE_ON_ONE_ROOMS_FAILURE,
  FETCH_MARK_NOTE_RESOLVED_REQUEST,
  FETCH_MARK_NOTE_RESOLVED_SUCCESS,
  FETCH_MARK_NOTE_RESOLVED_FAILURE,
  SET_FIELD_VALUES_FOR_POSITIONS,
  CREATE_ESTIMATE_CONFIG_REQUEST,
  CREATE_ESTIMATE_CONFIG_SUCCESS,
  CREATE_ESTIMATE_CONFIG_FAILURE,
  UPDATE_ESTIMATE_CONFIG_REQUEST,
  UPDATE_ESTIMATE_CONFIG_FAILURE,
  UPDATE_ESTIMATE_CONFIG_SUCCESS,
  DELETE_ESTIMATE_CONFIG_SUCCESS,
  DELETE_ESTIMATE_CONFIG_REQUEST,
  DELETE_ESTIMATE_CONFIG_FAILURE,
  FETCH_EVENT_DETAILS_STOP_LOADING,
  FETCH_ESTIMATE_CONFIG_REQUEST,
  FETCH_ESTIMATE_CONFIG_SUCCESS,
  FETCH_ESTIMATE_CONFIG_FAILURE,
  ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_REQUEST,
  ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_SUCCESS,
  ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_FAILURE,
  UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_REQUEST,
  UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_FAILURE,
  UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_SUCCESS,
  HALF_DAY_EVENT_CLICK_REQUEST,
  HALF_DAY_EVENT_CLICK_FAILURE,
  HALF_DAY_EVENT_CLICK_SUCCESS,
  HALF_DAY_POSITION_CLICK_REQUEST,
  HALF_DAY_POSITION_CLICK_FAILURE,
  HALF_DAY_POSITION_CLICK_SUCCESS,
  SUBMIT_INVOICE_CONFIG_REQUEST,
  SUBMIT_INVOICE_CONFIG_FAILURE,
  SUBMIT_INVOICE_CONFIG_SUCCESS,
  FETCH_INVOICE_CONFIG_REQUEST,
  FETCH_INVOICE_CONFIG_FAILURE,
  FETCH_INVOICE_CONFIG_SUCCESS,
  ADD_NEW_NOTE_CHAT_ROOM,
  OVERRIDE_POSITION_CLICK_SUCCESS,
  UPDATE_SUBTOTAL_TYPE_REQUEST,
  UPDATE_SUBTOTAL_TYPE_FAILURE,
  UPDATE_SUBTOTAL_TYPE_SUCCESS,
  FETCH_REIMBURSEMENT_CATEGORY_REQUEST,
  FETCH_REIMBURSEMENT_CATEGORY_FAILURE,
  FETCH_REIMBURSEMENT_CATEGORY_SUCCESS,
  GET_REIMBURSEMENT_AMOUNT_REQUEST,
  GET_REIMBURSEMENT_AMOUNT_FAILURE,
  GET_REIMBURSEMENT_AMOUNT_SUCCESS,
  SUBMIT_INVOICE_DATA_REQUEST,
  SUBMIT_INVOICE_DATA_FAILURE,
  SUBMIT_INVOICE_DATA_SUCCESS,
  GET_ALL_INVOICE_REQUEST,
  GET_ALL_INVOICE_SUCCESS,
  GET_ALL_INVOICE_FAILURE,
  GET_INVOICE_DATA_SUCCESS,
  DISMISS_CLIENT_CHANGES_REQUEST,
  DISMISS_CLIENT_CHANGES_SUCCESS,
  DISMISS_CLIENT_CHANGES_FAILURE,
  FETCH_SUBMITTED_INVOICE_REQUEST,
  FETCH_SUBMITTED_INVOICE_FAILURE,
  FETCH_SUBMITTED_INVOICE_SUCCESS,
  SWITCH_INVOICE_CONFIG,
  GET_DEPOSIT_INVOICE_AMOUNT_REQUEST,
  GET_DEPOSIT_INVOICE_AMOUNT_SUCCESS,
  GET_DEPOSIT_INVOICE_AMOUNT_FAILURE,
  ADD_EXTRA_EMAIL_SUCCESS,
  ADD_EXTRA_EMAIL_FAILURE,
  ADD_EXTRA_EMAIL_REQUEST,
  REMOVE_EXTRA_EMAIL_REQUEST,
  REMOVE_EXTRA_EMAIL_SUCCESS,
  REMOVE_EXTRA_EMAIL_FAILURE,
  POSITION_TERM_UPDATE_REQUEST,
  POSITION_TERM_UPDATE_FAILURE,
  POSITION_TERM_UPDATE_SUCCESS,
  CLEAR_CONTRACTOR_DIFFERENT_TIME,
  UNASSIGN_CONTRACTOR_REQUEST,
  UNASSIGN_CONTRACTOR_FAILURE,
  UNASSIGN_CONTRACTOR_SUCCESS,
  CALIFORNIA_CONTRACTOR_RATE_EVENT_REQUEST,
  CALIFORNIA_CONTRACTOR_RATE_EVENT_SUCCESS,
  CALIFORNIA_CONTRACTOR_RATE_EVENT_FAILURE,
  ASSIGN_COORDINATOR_META_DATA,
  SESSION_MANAGEMENT_META_DATA,
  REFRESH_RATE_LIST_FOR_EVENT_REQUEST,
  ADD_UPDATE_CLIENT_CONTRACTOR_RATE_REQUEST,
  ADD_UPDATE_CLIENT_CONTRACTOR_RATE_FAILURE,
  OVERRIDE_POSITION_CLICK_REQUEST,
  OVERRIDE_POSITION_CLICK_FAILURE,
  ADD_UPDATE_CLIENT_CONTRACTOR_RATE_SUCCESS,
  UPDATE_PO_UPDATE_NEEDED_KEY
} from "../constants/eventRequestDetails";
import {
  ACCEPT_REIMBURSEMENT_FAILURE,
  ACCEPT_REIMBURSEMENT_REQUEST,
  ACCEPT_REIMBURSEMENT_SUCCESS,
  CLAIM_REIMBURSEMENT_FAILURE,
  CLAIM_REIMBURSEMENT_REQUEST,
  CLAIM_REIMBURSEMENT_SUCCESS,
  REJECT_REIMBURSEMENT_FAILURE,
  REJECT_REIMBURSEMENT_REQUEST,
  REJECT_REIMBURSEMENT_SUCCESS
} from "../constants/schedule";
import { getConfigInvoice } from "../../utils/methods/estimate/estimateMethods";
import { UPDATE_LOCAL_PO_STATUS_OF_POSITIONS } from "../constants/contractor";
import {
  GET_DEDUCTION_AMOUNT_FAILURE,
  GET_DEDUCTION_AMOUNT_REQUEST,
  GET_DEDUCTION_AMOUNT_SUCCESS
} from "../constants/event/adjustments";

const initialState = {
  eventInfo: null,
  contactInfo: null,
  coordinators: [],
  sessions: [],
  sessionString: {},
  positions: {},
  filteredOptions: {
    positionOptions: [],
    contractorOptions: []
  },
  poUpdates: false,
  rawPositions: {},
  timeUpdateIds: [],
  estimatePositions: {},
  eventLogs: [],
  depositInvoiceAmount: null,
  depositInvoiceConfigAmount: {},
  config: null,
  invoiceConfig: null,
  allInvoice: [],
  invoiceData: {
    contactInfo: null,
    sessions: [],
    positions: {}
  },
  savedInvoices: [],
  scheduleResources: [],
  contentResources: {},
  isLoading: false,
  ptLoading: false,
  emailLoading: false,
  dLoading: false,
  caRateIdsLoading: [],
  invoiceLoader: false,
  allInvoiceLoader: false,
  isApproveEventLoading: false,
  eventHalfDayLoader: false,
  checkLoader: false,
  checkLoaderArr: [],
  positionHalfDayLoader: false,
  eventHalfDay: false,
  statusLoader: false,
  logsLoading: false,
  estimateConfigLoader: false,
  assignLoading: false,
  pLoading: false,
  newPositionLoading: false,
  scheduleLoading: false,
  contentLoading: false,
  reimLoading: false,
  savedInvoiceLoader: false,
  reimCategory: [],
  reimAmount: null,
  deductionAmount: null,
  approveTimeLoading: false,
  tabData: {
    eventDetailsTab: {
      selectedSession: null,
      pageNo: null,
      rpp: 25
    },
    reportedIssueTab: {
      selectedSession: null,
      pageNo: null,
      rpp: 25
    },
    assignContractorTab: {
      selectedSession: null,
      pageNo: null,
      rpp: 25
    },
    sessionManagementTab: {
      selectedSession: null,
      pageNo: null,
      rpp: 25
    }
  },
  eventNoteRoom: {},
  assignedUsers: [],
  // eventNoteUsers: [],
  eventNotesAssignUser: [],
  markNoteResolved: [],
  error: null,
  markReadLoading: false
};

const isClientAndContractorInputDiffernet = ({ pos, isCalifornia }) => {
  const haveConData = isContractorFieldsAvailable({ pos });

  return isClientAndConPosTermsDiffrent({ pos, isCalifornia }) && !haveConData;
};

const getRawPositions = (obj) => {
  let arr = [];
  Object.keys(obj)?.forEach((key) => {
    obj[key]?.forEach((pos) => arr.push(pos));
  });
  return arr;
};

const eventRequestDetailsReducer = (state = initialState, action) => {
  let data = {};
  let eHalfDay = false;

  function addContractorFirstBreak({ updatedPos, pos }) {
    if (
      pos?.firstBreak &&
      pos?.afterFirstBreakIn &&
      !pos?.contractorFirstBreak &&
      !pos?.contractorAfterFirstBreakIn
    ) {
      updatedPos.contractorFirstBreak = pos?.firstBreak;
      updatedPos.contractorAfterFirstBreakIn = pos?.afterFirstBreakIn;
    }
  }
  function addContractorSecondBreak({ updatedPos, pos }) {
    if (
      pos?.secondBreak &&
      pos?.afterSecondBreakIn &&
      !pos?.contractorSecondBreak &&
      !pos?.contractorAfterSecondBreakIn
    ) {
      updatedPos.contractorSecondBreak = pos?.secondBreak;
      updatedPos.contractorAfterSecondBreakIn = pos?.afterSecondBreakIn;
    }
  }

  switch (action.type) {
    case FETCH_EVENT_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true,
        pLoading: true,
        poUpdates: initialState?.poUpdates
      };
    case FETCH_EVENT_DETAILS_SUCCESS:
      return {
        ...state,
        eventInfo: action.payload.eventInfo,
        contactInfo: action.payload.contactInfo,
        coordinators: action.payload.coordinators,
        sessions: action.payload.sessions,
        // positions: action.payload.positions,
        scheduleResources: [],
        contentResources: {},
        isLoading: false,
        tabData: initialState?.tabData
      };
    // Rede de segurança do `finally`: desliga os loaders e NADA mais.
    // Chega depois do SUCCESS/FAILURE no caminho feliz (no-op) e é o que salva a tela se
    // aparecer um caminho novo que não passe por nenhum dos dois — o custo de errar aqui é
    // spinner eterno e mudo, então preferimos desligar duas vezes a não desligar nunca.
    case FETCH_EVENT_DETAILS_STOP_LOADING:
      return {
        ...state,
        isLoading: false,
        pLoading: false
      };
    case FETCH_EVENT_DETAILS_POSITIONS_SUCCESS: {
      const updateIds = new Set();
      let positionSet = new Set();
      let contractorSet = new Set();
      let positionOptions = [];
      let contractorOptions = [];
      const newPos = { ...(action?.payload?.positions || {}) };
      let poUpdatesNeeded = false;

      eHalfDay = false;
      Object.entries(newPos).forEach(([key, positions]) => {
        newPos[key] = positions?.map((pos) => {
          // NOTE: creating position filter set
          if (!positionSet.has(pos?.positionId) && pos?.positionId) {
            positionSet.add(pos?.positionId);
            positionOptions.push({
              name: pos?.positionName,
              value: pos?.positionId
            });
          }
          if (
            !contractorSet.has(pos?.assignedContractor) &&
            pos?.assignedContractor
          ) {
            contractorSet.add(pos?.assignedContractor);
            contractorOptions.push({
              name: pos?.preferredName || pos?.contractorName,
              value: pos?.assignedContractor
            });
          }

          // NOTE: start date ts
          // updatedPos.TSStartDate = new Date(pos?.startDate)?.getTime();

          if (
            (pos?.isShiftEditedAfterPOSent || pos?.isContractorChanged) &&
            !poUpdatesNeeded
          ) {
            poUpdatesNeeded = true;
          }
          const updatedPos = { ...pos };
          const isClientAndConDiff = isClientAndContractorInputDiffernet({
            pos,
            isCalifornia: state?.eventInfo?.terms?.californiaContractorPO_SOW
          });

          if (!eHalfDay && pos?.isHalfdayHours) {
            eHalfDay = true;
          }

          if (
            pos?.assignedContractor &&
            !pos?.actualStart &&
            !pos?.contractor_actualStart &&
            pos?.timeIn &&
            !isTimeTBD(pos?.timeIn)
          ) {
            updatedPos.actualStart = pos.timeIn;
            updateIds.add(pos._id);
          }

          if (
            !pos?.contractorActualStart &&
            !isTimeTBD(pos?.timeIn) &&
            isClientAndConDiff
          ) {
            updatedPos.contractorActualStart = pos?.actualStart || pos?.timeIn;
            updateIds.add(pos._id);
          }

          if (
            pos?.assignedContractor &&
            !pos?.actualEnd &&
            !pos?.contractor_actualEnd &&
            pos?.timeOut &&
            !isTimeTBD(pos?.timeOut)
          ) {
            updatedPos.actualEnd = pos.timeOut;
            updateIds.add(pos._id);
          }
          if (
            !pos?.contractorActualEnd &&
            !isTimeTBD(pos?.timeOut) &&
            isClientAndConDiff
          ) {
            updatedPos.contractorActualEnd = pos?.actualEnd || pos?.timeOut;
            updateIds.add(pos._id);
          }

          if (
            // pos?.assignedContractor &&
            // !pos?.actualEnd &&
            // !pos?.actualStart &&
            !isTimeTBD(pos?.timeIn) &&
            !isTimeTBD(pos?.timeOut) &&
            !pos?.oT &&
            !pos?.dT &&
            !pos?.actualMidnightOT
          ) {
            const isCalCase =
              state?.eventInfo?.terms?.californiaContractorPO_SOW;
            const estimateObj = getObjForPOCalculation({
              timezone: state?.eventInfo?.eventTimezone,
              pos,
              terms: getFinalTerms({ eventTerms: state?.eventInfo?.terms }),
              appliedRate: checkValidValue({ value: pos?.estimateAppliedRate })
                ? pos?.estimateAppliedRate
                : pos?.positionData?.defaultRate,
              isPrefill: true
            });
            const { otHours, dtHours, overT } = calcEstimateForPO(estimateObj);

            let noActualStartOREnd = !pos?.actualStart || !pos?.actualEnd;
            updatedPos.oT = !noActualStartOREnd
              ? null
              : formatValue(otHours).toString();
            updatedPos.dT = !noActualStartOREnd
              ? null
              : formatValue(dtHours).toString();
            updatedPos.actualMidnightOT = !noActualStartOREnd
              ? null
              : formatValue(overT).toString();
          }

          if (
            // pos?.assignedContractor &&
            // !pos?.contractorActualStart &&
            // !pos?.contractorActualEnd &&
            !isTimeTBD(pos?.timeIn) &&
            !isTimeTBD(pos?.timeOut) &&
            !pos?.contractorOT &&
            !pos?.contractorDT &&
            !pos?.contractorActualMidnightOT &&
            isClientAndConDiff
          ) {
            const isCalCase =
              state?.eventInfo?.terms?.californiaContractorPO_SOW;
            const estimateObj = getObjForPOCalculation({
              timezone: state?.eventInfo?.eventTimezone,
              pos,
              terms: getFinalTerms({ eventTerms: state?.eventInfo?.terms }),
              appliedRate: checkValidValue({ value: pos?.estimateAppliedRate })
                ? pos?.estimateAppliedRate
                : pos?.positionData?.defaultRate,
              isClient: false,
              isContractorDiff: true,
              disableGivenOTDT: true,
              isPrefill: true
            });
            const { otHours, dtHours, overT } = isCalCase
              ? calcEstimateForCaliforniaPO(estimateObj)
              : calcEstimateForPO(estimateObj);

            let noActualStartOREnd =
              !pos?.contractorActualStart || !pos?.contractorActualEnd;
            updatedPos.contractorOT = !noActualStartOREnd
              ? null
              : formatValue(otHours).toString();
            updatedPos.contractorDT = !noActualStartOREnd
              ? null
              : formatValue(dtHours).toString();
            updatedPos.contractorActualMidnightOT = !noActualStartOREnd
              ? null
              : formatValue(overT).toString();
            addContractorFirstBreak({ updatedPos, pos });
            addContractorSecondBreak({ updatedPos, pos });
          }

          return updatedPos;
        });
      });
      return {
        ...state,
        positions: newPos,
        filteredOptions: {
          positionOptions,
          contractorOptions
        },
        poUpdates: poUpdatesNeeded,
        sessionString: action?.payload?.sessionString,
        sessionStringWithoutBackup: action?.payload?.sessionStringWithoutBackup,
        rawPositions: getRawPositions(action?.payload?.positions),
        estimatePositions: newPos,
        timeUpdateIds: Array.from(updateIds),
        eventHalfDay:
          state?.eventInfo?.terms?.clientHalfDayInc ||
          state?.eventInfo?.terms?.contractorHalfDayInc,
        pLoading: false
      };
    }
    case FETCH_EVENT_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        pLoading: false
      };

    // set eventInfo
    case SET_EVENT_INFO:
      return {
        ...state,
        eventInfo: action?.payload?.eventInfo
      };

    // assign coordinator to event
    case ASSIGN_COORDINATOR_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ASSIGN_COORDINATOR_SUCCESS:
      return {
        ...state,
        coordinators: [...state.coordinators, action.payload],
        isLoading: false
      };
    case ASSIGN_COORDINATOR_FAILURE:
      return {
        ...state,
        isLoading: false
      };

    // remove session from event
    case REMOVE_SESSION_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case REMOVE_SESSION_SUCCESS:
      return {
        ...state,
        sessions: state.sessions.filter(
          (session) => session._id !== action.payload
        ),
        isLoading: false
      };
    case REMOVE_SESSION_FAILURE:
      return {
        ...state,
        isLoading: false
      };

    // remove position from event
    case REMOVE_POSITION_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case REMOVE_POSITION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        positions: {
          ...state.positions,
          [action.payload.sessionId]: state.positions[
            action.payload.sessionId
          ].filter((position) => position?._id !== action.payload.ppId)
        },
        estimatePositions: {
          ...state.estimatePositions,
          [action.payload.sessionId]: state.estimatePositions[
            action.payload.sessionId
          ].filter((position) => position?._id !== action.payload.ppId)
        }
      };
    case REMOVE_POSITION_FAILURE:
      return {
        ...state,
        isLoading: false
      };

    // remove coordinator from event
    case REMOVE_COORDINATOR_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case REMOVE_COORDINATOR_SUCCESS:
      return {
        ...state,
        isLoading: false,
        coordinators: state.coordinators.filter(
          (coordinator) => coordinator._id !== action.payload
        )
      };
    case REMOVE_COORDINATOR_FAILURE:
      return {
        ...state,
        isLoading: false
      };

    // add time difference
    case ADD_TIME_DIFFERENCE:
      return {
        ...state,
        positions: {
          ...state.positions,
          [action?.payload]: state.positions[action?.payload]?.map((pos) => {
            return {
              ...pos,
              positionData: {
                ...pos.positionData,
                // NOTE: remove the hard coded value
                // timeDiff: getTimeDifference(
                //   pos.positionData?.startTime,
                //   pos.positionData?.endTime,
                // ),
                timeDiff: 5
              }
            };
          })
        }
      };

    // submit estimate action
    case SUBMIT_ESTIMATE_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SUBMIT_ESTIMATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        eventInfo: {
          ...state.eventInfo,
          tax: action.payload?.tax,
          terms: action.payload?.terms,
          isEventEditedAfterEstimate: false
        }
      };
    case SUBMIT_ESTIMATE_FAILURE:
      return {
        ...state,
        isLoading: false
      };

    // update deposit invoice status
    case UPDATE_DEPOSIT_INVOICE_STATUS_REQUEST:
      return {
        ...state,
        dLoading: true
      };
    case UPDATE_DEPOSIT_INVOICE_STATUS_SUCCESS:
      return {
        ...state,
        dLoading: false
      };
    case UPDATE_DEPOSIT_INVOICE_STATUS_FAILURE:
      return {
        ...state,
        dLoading: false
      };

    // assign contractor to position
    case ASSIGN_CONTRACTOR_REQUEST:
      return {
        ...state,
        assignLoading: true,
        pLoading: true
      };
    case ASSIGN_CONTRACTOR_SUCCESS:
      return {
        ...state,
        positions: Object.entries(state.positions).reduce(
          (acc, [sessionId, positions]) => {
            const sessionIdsToUpdate = Array.isArray(action.payload?.sessionId)
              ? action.payload.sessionId
              : [action.payload?.sessionId];

            if (sessionIdsToUpdate.includes(sessionId)) {
              acc[sessionId] = positions.map((pos) => {
                let payloadData;

                if (Array.isArray(action.payload?.data)) {
                  const idx = action.payload?.data
                    ?.map?.((item) => item?.Id)
                    ?.findIndex?.((item) => {
                      return item === pos?._id;
                    });
                  if (idx >= 0) {
                    payloadData = action?.payload?.data?.[idx];
                  }
                } else {
                  if (pos?._id === action.payload?.data?.Id) {
                    payloadData = action?.payload?.data;
                  }
                }

                if (payloadData) {
                  return {
                    ...pos,
                    assignedContractor:
                      payloadData?.contractorId || pos?.assignedContractor,
                    contractorName:
                      action?.payload?.contractorName || pos?.contractorName,
                    assignedByName:
                      action?.payload?.assignedByName || pos?.assignedByName,
                    assignedById: payloadData?.assignedBy || pos?.assignedById,
                    isApproved: action?.payload?.isApproved,
                    isGustoApproved: action?.payload?.isGustoApproved,
                    contractorType: action?.payload?.contractorType
                  };
                } else {
                  return pos;
                }
              });
            } else {
              acc[sessionId] = positions;
            }
            return acc;
          },
          {}
        ),
        // positions: {
        //   ...state.positions,
        //   [action.payload?.sessionId]: state.positions[
        //     action.payload?.sessionId
        //   ].map((pos) => {
        //     if (pos?._id === action.payload?.data?.Id) {
        //       return {
        //         ...pos,
        //         assignedContractor:
        //           action.payload?.data?.contractorId || pos?.assignedContractor,
        //         contractorName:
        //           action?.payload?.contractorName || pos?.contractorName,
        //         assignedByName:
        //           action?.payload?.assignedByName || pos?.assignedByName,
        //         assignedById:
        //           action?.payload?.data?.assignedBy || pos?.assignedById,
        //         isApproved: action?.payload?.isApproved,
        //         isGustoApproved: action?.payload?.isGustoApproved,
        //         contractorType: action?.payload?.contractorType,
        //       };
        //     } else {
        //       return pos;
        //     }
        //   }),
        // },
        assignLoading: false,
        pLoading: false
      };
    case ASSIGN_CONTRACTOR_FAILURE:
      return {
        ...state,
        assignLoading: false,
        pLoading: false
      };

    // change assign by
    case CHANGE_ASSIGN_BY_REQUEST:
      return {
        ...state,
        assingLoading: true,
        pLoading: true
      };

    case CHANGE_ASSIGN_BY_SUCCESS:
      return {
        ...state,
        positions: {
          ...state.positions,
          [action.payload?.sessionId]: state.positions[
            action.payload?.sessionId
          ].map((pos) => {
            if (pos?._id === action.payload?.data?.Id) {
              return {
                ...pos,
                assignedContractor:
                  action.payload?.data?.contractorId || pos?.assignedContractor,
                contractorName:
                  action?.payload?.contractorName || pos?.contractorName,
                assignedByName:
                  action?.payload?.assignedByName || pos?.assignedByName,
                assignedById:
                  action?.payload?.data?.assignedBy || pos?.assignedById,
                isApproved: action?.payload?.isApproved,
                isGustoApproved: action?.payload?.isGustoApproved,
                contractorType: action?.payload?.contractorType
              };
            } else {
              return pos;
            }
          })
        },
        assignLoading: false,
        pLoading: false
      };

    case CHANGE_ASSIGN_BY_FAILURE:
      return {
        ...state,
        assignLoading: false,
        pLoading: false
      };

    //  refresh positions
    case REFRESH_POSITIONS_REQUEST:
      return {
        ...state,
        pLoading: true,
        poUpdates: initialState?.poUpdates
      };

    case REFRESH_POSITIONS_SUCCESS: {
      const updateIds1 = new Set();
      let positionSet = new Set();
      let contractorSet = new Set();
      let positionOptions = [];
      let contractorOptions = [];
      const newPos1 = { ...(action?.payload?.positions || {}) };

      let poUpdatesNeeded = false;
      eHalfDay = false;
      Object.entries(newPos1).forEach(([key, positions]) => {
        newPos1[key] = positions?.map((pos) => {
          // NOTE: creating position filter set
          if (!positionSet.has(pos?.positionId) && pos?.positionId) {
            positionSet.add(pos?.positionId);
            positionOptions.push({
              name: pos?.positionName,
              value: pos?.positionId
            });
          }
          if (
            !contractorSet.has(pos?.assignedContractor) &&
            pos?.assignedContractor
          ) {
            contractorSet.add(pos?.assignedContractor);
            contractorOptions.push({
              name: pos?.preferredName || pos?.contractorName,
              value: pos?.assignedContractor
            });
          }

          // NOTE: start date ts
          // updatedPos.TSStartDate = new Date(pos?.startDate)?.getTime();

          if (
            (pos?.isShiftEditedAfterPOSent || pos?.isContractorChanged) &&
            !poUpdatesNeeded
          ) {
            poUpdatesNeeded = true;
          }
          const updatedPos = { ...pos };
          const isClientAndConDiff = isClientAndContractorInputDiffernet({
            pos,
            isCalifornia: state?.eventInfo?.terms?.californiaContractorPO_SOW
          });

          if (!eHalfDay && pos?.isHalfdayHours) {
            eHalfDay = true;
          }

          if (
            pos?.assignedContractor &&
            !pos?.actualStart &&
            !pos?.contractor_actualStart &&
            pos?.timeIn &&
            !isTimeTBD(pos?.timeIn)
          ) {
            updatedPos.actualStart = pos.timeIn;
            updateIds1.add(pos._id);
          }

          if (
            !pos?.contractorActualStart &&
            !isTimeTBD(pos?.timeIn) &&
            isClientAndConDiff
          ) {
            updatedPos.contractorActualStart = pos?.actualStart || pos?.timeIn;
            updateIds1.add(pos._id);
          }

          if (
            pos?.assignedContractor &&
            !pos?.actualEnd &&
            !pos?.contractor_actualEnd &&
            pos?.timeOut &&
            !isTimeTBD(pos?.timeOut)
          ) {
            updatedPos.actualEnd = pos.timeOut;
            updateIds1.add(pos._id);
          }

          if (
            !pos?.contractorActualEnd &&
            !isTimeTBD(pos?.timeOut) &&
            isClientAndConDiff
          ) {
            updatedPos.contractorActualEnd = pos?.actualEnd || pos?.timeOut;
            updateIds1.add(pos._id);
          }

          if (
            // pos?.assignedContractor &&
            // !pos?.actualEnd &&
            // !pos?.actualStart &&
            !isTimeTBD(pos?.timeIn) &&
            !isTimeTBD(pos?.timeOut) &&
            !pos?.oT &&
            !pos?.dT &&
            !pos?.actualMidnightOT
          ) {
            const isCalCase =
              state?.eventInfo?.terms?.californiaContractorPO_SOW;
            const estimateObj = getObjForPOCalculation({
              timezone: state?.eventInfo?.eventTimezone,
              pos,
              terms: getFinalTerms({ eventTerms: state?.eventInfo?.terms }),
              appliedRate: checkValidValue({ value: pos?.estimateAppliedRate })
                ? pos?.estimateAppliedRate
                : pos?.positionData?.defaultRate,
              isPrefill: true
            });
            const { otHours, dtHours, overT } = calcEstimateForPO(estimateObj);

            let noActualStartOREnd = !pos?.actualStart || !pos?.actualEnd;
            updatedPos.oT = !noActualStartOREnd
              ? null
              : formatValue(otHours).toString();
            updatedPos.dT = !noActualStartOREnd
              ? null
              : formatValue(dtHours).toString();
            updatedPos.actualMidnightOT = !noActualStartOREnd
              ? null
              : formatValue(overT).toString();
          }

          if (
            // pos?.assignedContractor &&
            // !pos?.contractorActualStart &&
            // !pos?.contractorActualEnd &&
            !isTimeTBD(pos?.timeIn) &&
            !isTimeTBD(pos?.timeOut) &&
            !pos?.contractorOT &&
            !pos?.contractorDT &&
            !pos?.contractorActualMidnightOT &&
            isClientAndConDiff
          ) {
            const isCalCase =
              state?.eventInfo?.terms?.californiaContractorPO_SOW;
            const estimateObj = getObjForPOCalculation({
              timezone: state?.eventInfo?.eventTimezone,
              pos,
              terms: getFinalTerms({ eventTerms: state?.eventInfo?.terms }),
              appliedRate: checkValidValue({ value: pos?.estimateAppliedRate })
                ? pos?.estimateAppliedRate
                : pos?.positionData?.defaultRate,
              isClient: false,
              isContractorDiff: true,
              disableGivenOTDT: true,
              isPrefill: true
            });
            const { otHours, dtHours, overT } = isCalCase
              ? calcEstimateForCaliforniaPO(estimateObj)
              : calcEstimateForPO(estimateObj);

            let noActualStartOREnd =
              !pos?.contractorActualStart || !pos?.contractorActualEnd;
            updatedPos.contractorOT = !noActualStartOREnd
              ? null
              : formatValue(otHours).toString();
            updatedPos.contractorDT = !noActualStartOREnd
              ? null
              : formatValue(dtHours).toString();
            updatedPos.contractorActualMidnightOT = !noActualStartOREnd
              ? null
              : formatValue(overT).toString();
            addContractorFirstBreak({ updatedPos, pos });
            addContractorSecondBreak({ updatedPos, pos });
          }

          return updatedPos;
        });
      });
      return {
        ...state,
        pLoading: false,
        positions: newPos1,
        filteredOptions: {
          positionOptions,
          contractorOptions
        },
        poUpdates: poUpdatesNeeded,
        sessionString: action?.payload?.sessionString,
        sessionStringWithoutBackup: action?.payload?.sessionStringWithoutBackup,
        rawPositions: getRawPositions(action?.payload?.positions),
        timeUpdateIds: Array.from(updateIds1),
        estimatePositions: newPos1,
        sessions: action.payload?.sessions,
        eventHalfDay:
          state?.eventInfo?.terms?.clientHalfDayInc ||
          state?.eventInfo?.terms?.contractorHalfDayInc
      };
    }
    case REFRESH_POSITIONS_FAILURE:
      return {
        ...state,
        pLoading: false
      };

    // update session position
    case UPDATE_SESSION_POSITION_REQUEST:
      return {
        ...state,
        pLoading: true
      };
    case UPDATE_SESSION_POSITION_SUCCESS:
      return {
        ...state,
        pLoading: false
      };
    case UPDATE_SESSION_POSITION_FAILURE:
      return {
        ...state,
        pLoading: false
      };

    // update session
    case UPDATE_SESSION_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case UPDATE_SESSION_SUCCES:
      return {
        ...state,
        isLoading: false
      };
    case UPDATE_SESSION_FAILURE:
      return {
        ...state,
        isLoading: false
      };

    // toggle contractor privacy initials
    case TOGGLE_SHOW_CONTRACTOR_INITIALS_REQUEST:
      return {
        ...state,
        statusLoader: true
      };

    case TOGGLE_SHOW_CONTRACTOR_INITIALS_SUCCESS:
      return {
        ...state,
        statusLoader: false,
        eventInfo: {
          ...state.eventInfo,
          showContractorInitials: !state.eventInfo.showContractorInitials
        }
      };

    case TOGGLE_SHOW_CONTRACTOR_INITIALS_FAILURE:
      return {
        ...state,
        statusLoader: false
      };

    // set field for position
    case SET_FIELD_FOR_POSITION: {
      return {
        ...state,
        positions: {
          ...state.positions,
          [action.payload?.sessionId]: state.positions[
            action.payload?.sessionId
          ].map((position) => {
            if (position?._id === action.payload?.positionId) {
              return {
                ...position,
                [action.payload?.field]: action?.payload?.value,
                ...(action?.payload?.additionalUpdates || {}),
                ...(["firstMealPaid", "secondMealPaid"].includes(action.payload?.field)
                  ? {} : { isClientApproved: false })
              };
            } else {
              return position;
            }
          })
        }
      };
    }

    // set field valeus for positions
    case SET_FIELD_VALUES_FOR_POSITIONS:
      return {
        ...state,
        positions: {
          ...state.positions,
          [action.payload?.sessionId]: state.positions[
            action.payload?.sessionId
          ].map((position) => {
            if (action.payload?.positionIds?.includes(position?._id)) {
              return {
                ...position,
                [action.payload?.field]: action?.payload?.value,
                ...(action?.payload?.additionalUpdates[position?._id] || {}),
                isClientApproved: false
              };
            } else {
              return position;
            }
          })
        }
      };

    // fetch logs
    case FETCH_LOGS_REQUEST:
      return {
        ...state,
        logsLoading: true
      };
    case FETCH_LOGS_SUCCESS:
      return {
        ...state,
        logsLoading: false,
        eventLogs: action.payload
      };
    case FETCH_LOGS_FAILURE:
      return {
        ...state,
        logsLoading: false
      };

    // add new log action
    case CREATE_LOG_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case CREATE_LOG_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    case CREATE_LOG_FAILURE:
      return {
        ...state,
        isLoading: false
      };

    // refresh event
    case REFRESH_EVENT_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case REFRESH_EVENT_SUCCESS:
      return {
        ...state,
        eventInfo: action.payload?.eventInfo,
        isLoading: false
      };
    case REFRESH_EVENT_FAILURE:
      return {
        ...state,
        isLoading: false
      };

    // mark as complete
    case MARK_EVENT_COMPLETE_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case MARK_EVENT_COMPLETE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        eventInfo: { ...state.eventInfo, ...action.payload }
      };

    case MARK_EVENT_COMPLETE_FAILURE:
      return {
        ...state,
        isLoading: false
      };

    // submit invoice config
    case SUBMIT_INVOICE_CONFIG_REQUEST:
      return {
        ...state,
        invoiceLoader: true
      };

    case SUBMIT_INVOICE_CONFIG_FAILURE:
      return {
        ...state,
        invoiceLoader: false
      };

    case SUBMIT_INVOICE_CONFIG_SUCCESS:
      return {
        ...state,
        invoiceLoader: false
      };

    // add new position to session
    case ADD_NEW_POSITION_REQUEST:
      return {
        ...state,
        newPositionLoading: true
      };
    case ADD_NEW_POSITION_SUCCESS:
      return {
        ...state,
        newPositionLoading: false
      };
    case ADD_NEW_POSITION_FAILURE:
      return {
        ...state,
        newPositionLoading: false
      };

    // fetch schedule resources
    case FETCH_SCHEDULE_RESOURCES_REQUEST:
      return {
        ...state,
        scheduleLoading: true
      };

    case FETCH_SCHEDULE_RESOURCES_SUCCESS:
      return {
        ...state,
        scheduleResources: action.payload?.map((item) => {
          const ext = item?.fileName?.split(".")?.pop()?.toLowerCase();
          const type = getMediaType(ext);
          return {
            ...item,
            type,
            uploadDate: item?.uploadDate || null
          };
        }),
        scheduleLoading: false
      };

    case FETCH_SCHEDULE_RESOURCES_FAILURE:
      return {
        ...state,
        scheduleLoading: false
      };

    // fetch content resources
    case FETCH_CONTENT_RESOURCES_REQUEST:
      return {
        ...state,
        contentLoading: true
      };

    case FETCH_CONTENT_RESOURCES_SUCCESS:
      action.payload.forEach((item) => {
        const ext = item?.fileName?.split(".")?.pop()?.toLowerCase();
        const type = getMediaType(ext);
        data = {
          ...data,
          [type]: [
            ...(data[type] || []),
            {
              ...item,
              type,
              uploadDate: item?.uploadDate || null
            }
          ]
        };
      });
      return {
        ...state,
        contentResources: data,
        contentLoading: false
      };

    case FETCH_CONTENT_RESOURCES_FAILURE:
      return {
        ...state,
        contentLoading: false
      };

    // upload schedule resource
    case UPLOAD_SCHEDULE_RESOURCES_REQUEST:
      return {
        ...state,
        scheduleLoading: true
      };

    case UPLOAD_SCHEDULE_RESOURCES_SUCCESS:
      return {
        ...state,
        scheduleLoading: false
      };

    case UPLOAD_SCHEDULE_RESOURCES_FAILURE:
      return {
        ...state,
        scheduleLoading: false
      };

    // upload contnet resource
    case UPLOAD_CONTENT_RESOURCES_REQUEST:
      return {
        ...state,
        contentLoading: true
      };

    case UPLOAD_CONTENT_RESOURCES_SUCCESS:
      return {
        ...state,
        contentLoading: false
      };
    case UPLOAD_CONTENT_RESOURCES_FAILURE:
      return {
        ...state,
        contentLoading: false
      };

    // delete schedule resources data for that event
    case DELETE_SCHEDULE_RESOURCES_REQUEST:
      return {
        ...state,
        scheduleLoading: true
      };

    case DELETE_SCHEDULE_RESOURCES_SUCCESS:
      return {
        ...state,
        scheduleLoading: false,
        scheduleResources: state.scheduleResources.filter(
          (item) => item._id !== action.payload
        )
      };

    case DELETE_SCHEDULE_RESOURCES_FAILURE:
      return {
        ...state,
        scheduleLoading: false
      };

    // delete content resource data from the event
    case DELETE_CONTENT_RESOURCES_REQUEST:
      return {
        ...state,
        contentLoading: true
      };

    case DELETE_CONTENT_RESOURCES_SUCCESS:
      data = {};
      Object.keys(state.contentResources).forEach((key) => {
        data[key] = state.contentResources[key].filter(
          (item) => item._id !== action.payload
        );
      });
      return {
        ...state,
        contentLoading: false,
        contentResources: data
      };
    case DELETE_CONTENT_RESOURCES_FAILURE:
      return {
        ...state,
        contentLoading: false
      };

    // delete all content files
    case DELETE_ALL_CONTENT_FILES_REQUEST:
      return {
        ...state,
        contentLoading: true
      };
    case DELETE_ALL_CONTENT_FILES_SUCCESS:
      return {
        ...state,
        contentLoading: false,
        contentResources: {}
      };
    case DELETE_ALL_CONTENT_FILES_FAILURE:
      return {
        ...state,
        contentLoading: false
      };

    // delete all schedule files
    case DELETE_ALL_SCHEDULE_FILES_REQUEST:
      return {
        ...state,
        scheduleLoading: true
      };
    case DELETE_ALL_SCHEDULE_FILES_SUCCESS:
      return {
        ...state,
        scheduleLoading: false,
        scheduleResources: []
      };
    case DELETE_ALL_SCHEDULE_FILES_FAILURE:
      return {
        ...state,
        scheduleLoading: false
      };

    case CLAIM_REIMBURSEMENT_REQUEST:
      return {
        ...state,
        reimLoading: true
      };

    case CLAIM_REIMBURSEMENT_SUCCESS:
      return {
        ...state,
        reimLoading: false,
        positions: {
          ...state?.positions,
          [action?.payload?.sessionId]: state?.positions[
            action?.payload?.sessionId
          ]?.map((pos) => {
            if (pos?._id === action?.payload?.id) {
              return action?.payload?.newData;
            } else {
              return pos;
            }
          })
        }
      };

    case CLAIM_REIMBURSEMENT_FAILURE:
      return {
        ...state,
        reimLoading: false
      };

    // accept reimbursement
    case ACCEPT_REIMBURSEMENT_REQUEST:
      return {
        ...state,
        reimLoading: true
      };
    case ACCEPT_REIMBURSEMENT_SUCCESS:
      return {
        ...state,
        reimLoading: false,
        positions: {
          ...state?.positions,
          [action?.payload?.sessionId]: state?.positions[
            action?.payload?.sessionId
          ]?.map((pos) => {
            if (pos?._id === action?.payload?.id) {
              return {
                ...pos,
                reImbursement: [
                  ...(action?.payload?.newData?.reImbursement || [])
                ]
              };
            } else {
              return pos;
            }
          })
        }
      };
    case ACCEPT_REIMBURSEMENT_FAILURE:
      return {
        ...state,
        reimLoading: false
      };

    // reject reimbursement
    case REJECT_REIMBURSEMENT_REQUEST:
      return {
        ...state,
        reimLoading: true
      };

    case REJECT_REIMBURSEMENT_SUCCESS:
      return {
        ...state,
        reimLoading: false,
        positions: {
          ...state?.positions,
          [action?.payload?.sessionId]: state?.positions[
            action?.payload?.sessionId
          ]?.map((pos) => {
            if (pos?._id === action?.payload?.id) {
              return {
                ...pos,
                reImbursement: [
                  ...(action?.payload?.newData?.reImbursement || [])
                ]
              };
            } else {
              return pos;
            }
          })
        }
      };

    case REJECT_REIMBURSEMENT_FAILURE:
      return {
        ...state,
        reimLoading: false
      };

    // approve time
    case APPROVE_TIME_REQUEST:
      return {
        ...state,
        approveTimeLoading: true
      };

    case APPROVE_TIME_SUCCESS:
      return {
        ...state,
        approveTimeLoading: false,
        positions: {
          ...state.positions,
          [action?.payload?.sessionId]: state.positions[
            action?.payload?.sessionId
          ]?.map((pos) => {
            if (pos?._id === action?.payload?.id) {
              return {
                ...pos,
                isClientApproved: true,
                isClientReApproved: true
              };
            } else {
              return pos;
            }
          })
        }
      };

    case APPROVE_TIME_FAILURE:
      return {
        ...state,
        approveTimeLoading: false
      };

    // event details tab selected session
    case EVENT_DETAILS_TAB_SELECTED_SESSION:
      return {
        ...state,
        tabData: {
          ...state?.tabData,
          eventDetailsTab: {
            ...state?.tabData?.eventDetailsTab,
            selectedSession: action?.payload
          }
        }
      };

    // event details tab selected page
    case EVENT_DETAILS_TAB_SELECTED_PAGE:
      return {
        ...state,
        tabData: {
          ...state?.tabData,
          eventDetailsTab: {
            ...state?.tabData?.eventDetailsTab,
            pageNo: action?.payload
          }
        }
      };

    // event reprot tab selected session
    case EVENT_REPORTED_TAB_SELECTED_SESSION:
      return {
        ...state,
        tabData: {
          ...state?.tabData,
          reportedIssueTab: {
            ...state?.tabData?.reportedIssueTab,
            selectedSession: action?.payload
          }
        }
      };

    // event details tab selected page
    case EVENT_REPORTED_TAB_SELECTED_PAGE:
      return {
        ...state,
        tabData: {
          ...state?.tabData,
          reportedIssueTab: {
            ...state?.tabData?.reportedIssueTab,
            pageNo: action?.payload
          }
        }
      };
    case EVENT_ADD_NOTE_REQUEST:
      return {
        ...state,
        error: null
      };

    case EVENT_ADD_NOTE_SUCCESS:
      return {
        ...state,
        eventNoteRoom: action.payload,
        error: null
      };

    case EVENT_ADD_NOTE_FAILURE:
      return {
        ...state,
        error: action.payload || "Failed to add note"
      };

    case FETCH_ASSIGNED_USERS_REQUEST:
      return {
        ...state,
        error: null,
        assignedUsers: []
      };

    case FETCH_ASSIGNED_USERS_SUCCESS:
      return {
        ...state,
        assignedUsers: action.payload.data,
        error: null
      };
    case FETCH_ASSIGNED_USERS_FAILURE:
      return {
        ...state,
        error: action.payload || "Failed to get event users"
      };
    // case FETCH_ONE_ON_ONE_NOTES_REQUEST:
    //   return {
    //     ...state,
    //     error: null,
    //     eventNoteUsers: []
    // };

    // case FETCH_ONE_ON_ONE_NOTES_SUCCESS:
    //   return {
    //     ...state,
    //     eventNoteUsers: action.payload.data,
    //     error: null,
    //   };
    // case FETCH_ONE_ON_ONE_NOTES_FAILURE:
    //   return {
    //     ...state,
    //     error: action.payload || "Failed to get event users",
    // }

    case FETCH_ONE_ON_ONE_ROOMS_REQUEST:
      return {
        ...state,
        error: null,
        eventNotesAssignUser: []
      };

    case FETCH_ONE_ON_ONE_ROOMS_SUCCESS:
      return {
        ...state,
        eventNotesAssignUser: Array.isArray(action.payload.data)
          ? action?.payload?.data
          : [],
        error: null
      };

    case FETCH_ONE_ON_ONE_ROOMS_FAILURE:
      return {
        ...state,
        error: action.payload || "Failed to get event users"
      };

    case ADD_NEW_NOTE_CHAT_ROOM: {
      return {
        ...state,
        eventNotesAssignUser: [
          ...(state?.eventNotesAssignUser || []),
          action?.payload?.newChatRoom
        ]
      };
    }

    case FETCH_MARK_NOTE_RESOLVED_REQUEST:
      return {
        ...state,
        error: null,
        markNoteResolved: []
      };

    case FETCH_MARK_NOTE_RESOLVED_SUCCESS:
      return {
        ...state,
        markNoteResolved: [...state.markNoteResolved, action.payload.data],
        error: null
      };
    case FETCH_MARK_NOTE_RESOLVED_FAILURE:
      return {
        ...state,
        error: action.payload || "Failed to get mark note resolved"
      };

    // create estimate config
    case CREATE_ESTIMATE_CONFIG_REQUEST:
      return {
        ...state,
        estimateConfigLoader: true
      };

    case CREATE_ESTIMATE_CONFIG_FAILURE:
      return {
        ...state,
        estimateConfigLoader: false
      };

    case CREATE_ESTIMATE_CONFIG_SUCCESS:
      return {
        ...state
      };

    // update estimate config
    case UPDATE_ESTIMATE_CONFIG_REQUEST:
      return {
        ...state,
        estimateConfigLoader: true
      };

    case UPDATE_ESTIMATE_CONFIG_FAILURE:
      return {
        ...state,
        estimateConfigLoader: false
      };

    case UPDATE_ESTIMATE_CONFIG_SUCCESS:
      return {
        ...state
      };

    // delete estimate config
    case DELETE_ESTIMATE_CONFIG_REQUEST:
      return {
        ...state,
        estimateConfigLoader: true
      };
    case DELETE_ESTIMATE_CONFIG_FAILURE:
      return {
        ...state,
        estimateConfigLoader: false
      };

    case DELETE_ESTIMATE_CONFIG_SUCCESS:
      return {
        ...state,
        config: state?.config?.filter((item) => action?.payload !== item?._id)
      };

    case FETCH_ESTIMATE_CONFIG_REQUEST:
      return {
        ...state,
        config: null,
        estimateConfigLoader: true
      };

    case FETCH_ESTIMATE_CONFIG_FAILURE:
      return {
        ...state,
        estimateConfigLoader: false,
        config: null
      };

    case FETCH_ESTIMATE_CONFIG_SUCCESS: {
      // 🔴 `getSubmittedConfiguredEstimateClient` devolve `data: [evento]` — um ARRAY de um
      // elemento, não o documento do evento. Lendo `action.payload.configurations` direto do
      // array dava `undefined`, os dois filtros viravam `[]` e **`config` ficava VAZIO**.
      // Consequência em cascata na aba de estimate do cliente:
      //   • `config?.[selectedConfigTab?.tabValue]` → undefined
      //   • `isEstimateButtonDisableForClient(undefined)` → `undefined && …` é falsy → return true
      //   → o botão **"Approve" renderizava DESABILITADO** e o clique não fazia absolutamente
      //     nada: sem modal, sem request, sem log. Reproduzido em dev 05/08 (IPMA), onde o
      //     estimate estava submetido e NÃO aprovado — ou seja, o cliente deveria poder aprovar.
      //   • `selectedConfigTab.sessionIds = config?.[0]?.sessionId` → undefined, o que também
      //     mascarava o filtro de sessions.
      // Aceitamos as duas formas: o handler do admin (`getSubmittedConfiguredEstimate`) pode
      // devolver o doc direto, e este reducer é compartilhado pelos dois caminhos.
      const raw = action?.payload;
      const eventDoc = Array.isArray(raw) ? raw[0] : raw;
      const configurations = Array.isArray(eventDoc?.configurations)
        ? eventDoc.configurations
        : [];
      return {
        ...state,
        estimateConfigLoader: false,
        // Master config primeiro, resto depois — ordem original preservada.
        config: [
          ...configurations.filter(
            (item) => item?.estimateName === DEFAULT_ESTIMATE_NAME
          ),
          ...configurations.filter(
            (item) => item?.estimateName !== DEFAULT_ESTIMATE_NAME
          )
        ]
      };
    }

    // fetch invoice config
    case FETCH_INVOICE_CONFIG_REQUEST:
      return {
        ...state,
        invoiceConfig: null,
        estimateConfigLoader: true
      };

    case FETCH_INVOICE_CONFIG_FAILURE:
      return {
        ...state,
        estimateConfigLoader: false,
        invoiceConfig: null
      };

    case FETCH_INVOICE_CONFIG_SUCCESS:
      return {
        ...state,
        estimateConfigLoader: false,
        invoiceConfig:
          [
            ...(action?.payload?.configurations?.filter(
              (item) => item?.estimateName === DEFAULT_ESTIMATE_NAME
            ) || []),
            ...(action?.payload?.configurations?.filter(
              (item) => item?.estimateName !== DEFAULT_ESTIMATE_NAME
            ) || [])
          ] || []
      };

    // assign contractor to multiple positons
    case ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_REQUEST:
      return {
        ...state,
        assignLoading: true,
        pLoading: true
      };

    case ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_FAILURE:
      return {
        ...state,
        assignLoading: false,
        pLoading: false
      };

    case ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_SUCCESS:
      return {
        ...state,
        assignLoading: false,
        pLoading: false,
        positions: Object.fromEntries(
          Object.entries(state?.positions).map(([sessionId, posArray]) => [
            sessionId,
            posArray?.map((pos) => {
              if (action?.payload?.errorIds?.includes(pos?._id)) return pos;
              if (action?.payload?.data?.positionIds?.includes(pos?._id)) {
                return {
                  ...pos,
                  ...(action?.payload?.data?.additionalData || {})
                };
              } else {
                return pos;
              }
            })
          ])
        )
      };

    // assign contractor to multiple positons
    case UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_REQUEST:
      return {
        ...state,
        assignLoading: true,
        pLoading: true
      };

    case UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_FAILURE:
      return {
        ...state,
        assignLoading: false,
        pLoading: false
      };

    case UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_SUCCESS:
      return {
        ...state,
        assignLoading: false,
        pLoading: false,
        positions: Object.fromEntries(
          Object.entries(state.positions).map(([sessionId, posArray]) => [
            sessionId,
            posArray.map((pos) => {
              if (action?.payload?.positionIds?.includes(pos?._id)) {
                return {
                  ...pos,
                  ...(action?.payload?.additionalData || {})
                };
              } else {
                return pos;
              }
            })
          ])
        )
      };

    case "UPDATE_APPLIED_RATE_OF_POSITION": {
      let filterList = [];
      const newPositions = {
        ...(state?.positions || {}),
        [action?.payload?.sessionId]: state?.positions?.[
          action?.payload?.sessionId
        ]?.map((item) => {
          if (item?._id === action?.payload?.data?.id) {
            filterList.push(item?._id);
            return {
              ...item,
              estimateAppliedRate: action?.payload?.data?.estimateAppliedRate,
              isClientRateChanged: false
            };
          } else {
            return item;
          }
        })
      };
      const newCheckLoaderArr = state?.checkLoaderArr?.filter(
        (p) => !filterList?.includes(p?._id)
      );
      return {
        ...state,
        positions: newPositions,
        checkLoader: false,
        checkLoaderArr: newCheckLoaderArr
      };
    }

    case "UPDATE_APPLIED_RATE_OF_MULTIPLE_POSITIONS": {
      const updatedPositionsIdsList = action?.payload?.map((p) => p?.data?.id);
      const sessionIdToUpdate = action?.payload?.[0]?.sessionId;
      const newRateToUpdate = action?.payload?.[0]?.data?.estimateAppliedRate;
      let filterList = [];
      const newPositions = {
        ...(state?.positions || {}),
        [sessionIdToUpdate]: state?.positions?.[sessionIdToUpdate]?.map(
          (item) => {
            if (updatedPositionsIdsList?.includes(item?._id)) {
              filterList.push(item?._id);
              return {
                ...item,
                estimateAppliedRate: newRateToUpdate,
                isClientRateChanged: false
              };
            } else {
              return item;
            }
          }
        )
      };
      const newCheckLoaderArr = state?.checkLoaderArr?.filter(
        (p) => !filterList?.includes(p?._id)
      );
      return {
        ...state,
        positions: newPositions,
        checkLoader: false,
        checkLoaderArr: newCheckLoaderArr
      };
    }

    case "UPDATE_APPLIED_CONTRACTOR_RATE_OF_POSITION":
      return {
        ...state,
        positions: {
          ...(state?.positions || {}),
          [action?.payload?.sessionId]: state?.positions?.[
            action?.payload?.sessionId
          ]?.map((item) => {
            if (item?._id === action?.payload?.data?.id) {
              return {
                ...item,
                updatedContractorRate:
                  action?.payload?.data?.updatedContractorRate,
                californiaContractorRate:
                  action?.payload?.data?.californiaContractorRate
              };
            } else {
              return item;
            }
          })
        }
      };

    case "UPDATE_APPLIED_CONTRACTOR_RATE_OF_MULTIPLE_POSITIONS": {
      const updatedPositionsIdsList = action?.payload?.map((p) => p?.data?.id);
      const sessionIdToUpdate = action?.payload?.[0]?.sessionId;
      const newRateToUpdate = action?.payload?.[0]?.data?.updatedContractorRate;
      const updatedCaliforniaRate =
        action?.payload?.[0]?.data?.californiaContractorRate;
      return {
        ...state,
        positions: {
          ...(state?.positions || {}),
          [sessionIdToUpdate]: state?.positions?.[sessionIdToUpdate]?.map(
            (item) => {
              if (updatedPositionsIdsList?.includes(item?._id)) {
                return {
                  ...item,
                  updatedContractorRate: newRateToUpdate,
                  californiaContractorRate: updatedCaliforniaRate
                };
              } else {
                return item;
              }
            }
          )
        }
      };
    }

    case CALIFORNIA_CONTRACTOR_RATE_EVENT_REQUEST:
      return {
        ...state,
        caRateIdsLoading: action?.payload
      };
    case CALIFORNIA_CONTRACTOR_RATE_EVENT_SUCCESS:
      return {
        ...state,
        caRateIdsLoading: []
      };
    case CALIFORNIA_CONTRACTOR_RATE_EVENT_FAILURE:
      return {
        ...state,
        caRateIdsLoading: []
      };

    case "UPDATE_CA_CONTRACTOR_RATE_OF_POSITION": {
      let caRateObj = {};
      let newPositions = {};
      const positionList = action?.payload?.map((item) => {
        caRateObj[item?.id] = item?.californiaContractorRate;
        return item?.id;
      });

      Object.keys(state?.positions)?.forEach((sessionId) => {
        state?.positions?.[sessionId]?.forEach((pos) => {
          if (!isArray(newPositions[sessionId])) {
            newPositions[sessionId] = [];
          }
          if (positionList?.includes(pos?._id)) {
            newPositions[sessionId]?.push({
              ...pos,
              californiaContractorRate:
                caRateObj?.[pos?._id] || pos?.californiaContractorRate || 0
            });
          } else {
            newPositions[sessionId]?.push(pos);
          }
        });
      });
      return {
        ...state,
        positions: newPositions
      };
    }

    case "UPDATE_TERMS_OF_EVENT":
      return {
        ...state,
        eventInfo: {
          ...state?.eventInfo,
          ...(action?.payload || {})
        }
      };

    // half day event click
    case HALF_DAY_EVENT_CLICK_REQUEST: {
      return {
        ...state,
        eventHalfDayLoader: true,
        checkLoaderArr: [
          ...(action?.payload?.map((p) => p?.id) || []),
          ...(state?.checkLoaderArr || [])
        ],
        checkLoader: true
      };
    }

    case HALF_DAY_EVENT_CLICK_FAILURE:
      return {
        ...state,
        eventHalfDayLoader: false,
        checkLoader: false,
        checkLoaderArr: []
      };

    case HALF_DAY_EVENT_CLICK_SUCCESS: {
      let filterList = [];
      let eventHalfDay = false;
      const updatedPositions = { ...state.positions };

      action.payload?.data?.forEach(
        ({ id, estimateAppliedRate, isHalfdayHours }) => {
          Object.entries(updatedPositions).forEach(([sessionId, posArr]) => {
            updatedPositions[sessionId] = posArr.map((pos) => {
              if (pos._id === id) {
                filterList.push(pos?._id);
                return {
                  ...pos,
                  estimateAppliedRate,
                  isHalfdayHours,
                  isClientRateChanged: false
                };
              } else {
                return pos;
              }
            });
          });
        }
      );

      Object.entries(updatedPositions).forEach(([sessionId, posArr]) => {
        posArr?.forEach((pos) => {
          if (pos?.isHalfdayHours) {
            if (!eventHalfDay) {
              eventHalfDay = true;
            }
          }
        });
      });

      const newCheckLoaderArr = [
        ...(state?.checkLoaderArr?.filter(
          (p) => !filterList?.includes(p?._id)
        ) || [])
      ];

      return {
        ...state,
        eventHalfDayLoader: false,
        eventHalfDay: isUndefined(action?.payload?.status)
          ? state?.eventInfo?.terms?.clientHalfDayInc ||
            state?.eventInfo?.terms?.contractorHalfDayInc
          : action?.payload?.status,
        positions: updatedPositions,
        checkLoader: false,
        checkLoaderArr: newCheckLoaderArr
      };
    }

    // half day position click
    case HALF_DAY_POSITION_CLICK_REQUEST: {
      return {
        ...state,
        positionHalfDayLoader: true,
        checkLoader: true,
        checkLoaderArr: [
          ...(action?.payload?.map((p) => p?.id) || []),
          ...(state?.checkLoaderArr || [])
        ]
      };
    }

    case HALF_DAY_POSITION_CLICK_FAILURE:
      return {
        ...state,
        positionHalfDayLoader: false,
        checkLoaderArr: [],
        checkLoader: false
      };

    case HALF_DAY_POSITION_CLICK_SUCCESS: {
      let filterList = [];
      const updatedPositions1 = { ...state.positions };

      action.payload?.data?.forEach(
        ({
          id,
          estimateAppliedRate,
          isHalfdayHours,
          isHalfDayManualOverride
        }) => {
          Object.entries(updatedPositions1).forEach(([sessionId, posArr]) => {
            updatedPositions1[sessionId] = posArr.map((pos) => {
              if (pos._id === id) {
                filterList.push(pos?._id);
                return {
                  ...pos,
                  estimateAppliedRate,
                  isHalfdayHours,
                  isHalfDayManualOverride,
                  isClientRateChanged: false
                };
              } else {
                return pos;
              }
            });
          });
        }
      );

      const newCheckLoaderArr = state?.checkLoaderArr?.filter(
        (p) => !filterList.includes(p?._id)
      );

      return {
        ...state,
        positionHalfDayLoader: false,
        positions: updatedPositions1,
        checkLoaderArr: newCheckLoaderArr,
        checkLoader: false
      };
    }

    // post applied rate for event request
    case POST_APPLIED_RATE_EVENT_REQUEST_REQUEST:
      return {
        ...state,
        checkLoaderArr: [...(state?.checkLoaderArr || []), action?.payload],
        checkLoader: true
      };

    case POST_APPLIED_RATE_EVENT_REQUEST_FAILURE:
      return {
        ...state,
        checkLoaderArr: [],
        checkLoader: false
      };

    // override click for position
    case OVERRIDE_POSITION_CLICK_REQUEST: {
      return {
        ...state,
        positionHalfDayLoader: true
      };
    }

    case OVERRIDE_POSITION_CLICK_FAILURE:
      return {
        ...state,
        positionHalfDayLoader: false
      };

    case OVERRIDE_POSITION_CLICK_SUCCESS:
      const updatedPositions2 = { ...state.positions };

      action.payload?.data?.forEach(({ id, isHalfDayManualOverride }) => {
        Object.entries(updatedPositions2).forEach(([sessionId, posArr]) => {
          updatedPositions2[sessionId] = posArr.map((pos) =>
            pos._id === id
              ? {
                  ...pos,
                  isHalfDayManualOverride
                }
              : pos
          );
        });
      });

      return {
        ...state,
        positionHalfDayLoader: false,
        positions: updatedPositions2
      };

    // update subtotal type
    case UPDATE_SUBTOTAL_TYPE_REQUEST:
      return {
        ...state
      };

    case UPDATE_SUBTOTAL_TYPE_FAILURE:
      return {
        ...state
      };

    case UPDATE_SUBTOTAL_TYPE_SUCCESS:
      return {
        ...state,
        invoiceConfig: state?.invoiceConfig?.map((item) => {
          if (item?._id == action?.payload?.configId) {
            return { ...item, invoiceType: action?.payload?.type };
          } else {
            return item;
          }
        })
      };

    // reimbursement category
    case FETCH_REIMBURSEMENT_CATEGORY_REQUEST:
      return state;

    case FETCH_REIMBURSEMENT_CATEGORY_FAILURE:
      return state;

    case FETCH_REIMBURSEMENT_CATEGORY_SUCCESS:
      return {
        ...state,
        reimCategory: action?.payload
      };

    // reimbursemet amount for invoice
    case GET_REIMBURSEMENT_AMOUNT_REQUEST:
      return state;
    case GET_REIMBURSEMENT_AMOUNT_FAILURE:
      return state;
    case GET_REIMBURSEMENT_AMOUNT_SUCCESS:
      return {
        ...state,
        reimAmount: action?.payload
      };

    // deduction amount for invoice
    case GET_DEDUCTION_AMOUNT_REQUEST:
      return state;
    case GET_DEDUCTION_AMOUNT_FAILURE:
      return state;
    case GET_DEDUCTION_AMOUNT_SUCCESS:
      return {
        ...state,
        deductionAmount: action?.payload
      };

    // return state;

    case "UPDATE_ESTIMATE_PO_NUMBER":
      return {
        ...state,
        config: state?.config?.map((item) => {
          if (item?._id === action?.payload?.configId) {
            return {
              ...item,
              PONumber: action?.payload?.poNumber
            };
          } else {
            return item;
          }
        })
      };

    case "UPDATE_INVOICE_PO_NUMBER":
      return {
        ...state,
        invoiceConfig: state?.invoiceConfig?.map((item) => {
          if (item?._id === action?.payload?.configId) {
            return {
              ...item,
              invoicePONumber: action?.payload?.poNumber
            };
          } else {
            return item;
          }
        })
      };

    // submit invoice data
    case SUBMIT_INVOICE_DATA_REQUEST:
      return {
        ...state,
        invoiceLoader: true
      };

    case SUBMIT_INVOICE_DATA_FAILURE:
      return {
        ...state,
        invoiceLoader: false
      };

    case SUBMIT_INVOICE_DATA_SUCCESS:
      return {
        ...state,
        invoiceLoader: false
      };

    // get invoice data success
    case GET_INVOICE_DATA_SUCCESS:
      const newPositions = {};
      const newSessions = action?.payload?.sessions?.map((ses) => {
        const { positions, ...rest } = ses;
        newPositions[ses?._id] = [
          ...(ses?.positions?.map((item) => ({
            ...item,
            session: { _id: ses?._id, sessionName: ses?.sessionName }
          })) || [])
        ];
        return rest;
      });

      return {
        ...state,
        invoiceData: {
          contactInfo: action?.payload?.contactInformation,
          sessions: newSessions,
          positions: newPositions,
          reimAmount: action?.payload?.reimbursementCategoryTotals
        }
      };

    // get all invoice data
    case GET_ALL_INVOICE_REQUEST:
      return {
        ...state,
        allInvoiceLoader: true
      };

    case GET_ALL_INVOICE_FAILURE:
      return {
        ...state,
        allInvoiceLoader: false
      };

    case GET_ALL_INVOICE_SUCCESS:
      return {
        ...state,
        allInvoiceLoader: false,
        allInvoice: action?.payload
      };

    // update po number
    case UPDATE_PO_NUMBER_SUCCESS:
      return {
        ...state,
        config:
          [
            ...(action?.payload?.configurations?.filter(
              (item) => item?.estimateName === DEFAULT_ESTIMATE_NAME
            ) || []),
            ...(action?.payload?.configurations?.filter(
              (item) => item?.estimateName !== DEFAULT_ESTIMATE_NAME
            ) || [])
          ] || []
      };

    // dismiss client changes
    case DISMISS_CLIENT_CHANGES_REQUEST:
      return {
        ...state,
        markReadLoading: true
      };

    case DISMISS_CLIENT_CHANGES_SUCCESS:
      return {
        ...state,
        markReadLoading: false,
        eventInfo: { ...state?.eventInfo, eventEditedByClient: false }
      };
    case DISMISS_CLIENT_CHANGES_FAILURE:
      return {
        ...state,
        markReadLoading: false
      };

    // fetchsubmitted invoices
    case FETCH_SUBMITTED_INVOICE_REQUEST:
      return {
        ...state,
        savedInvoiceLoader: true
      };
    case FETCH_SUBMITTED_INVOICE_FAILURE:
      return {
        ...state,
        savedInvoiceLoader: false
      };
    case FETCH_SUBMITTED_INVOICE_SUCCESS: {
      let savedConfigs = getConfigInvoice({ configs: action?.payload });
      return {
        ...state,
        savedInvoiceLoader: false,
        savedInvoices: savedConfigs,
        invoiceData: savedConfigs?.[Object.keys(savedConfigs)?.[0]]
      };
    }

    // switch config
    case SWITCH_INVOICE_CONFIG:
      return {
        ...state,
        invoiceData: state?.savedInvoices?.[action?.payload]
      };

    // receive deposit invoice amount
    case GET_DEPOSIT_INVOICE_AMOUNT_REQUEST:
      return {
        ...state,
        invoiceLoader: true
      };

    case GET_DEPOSIT_INVOICE_AMOUNT_SUCCESS:
      return {
        ...state,
        depositInvoiceAmount: action?.payload?.totalReceivedDepositAmount || 0,
        depositInvoiceConfigAmount:
          action?.payload?.configurationGrandTotal?.reduce((acc, item) => {
            acc[item?.id] = item?.total;
            return acc;
          }, {}),
        depositInoviceStatuses: action?.payload,
        invoiceLoader: false
      };

    case GET_DEPOSIT_INVOICE_AMOUNT_FAILURE:
      return {
        ...state,
        invoiceLoader: false
      };

    // add extra email
    case ADD_EXTRA_EMAIL_REQUEST:
      return {
        ...state,
        emailLoading: true
      };
    case ADD_EXTRA_EMAIL_FAILURE:
      return {
        ...state,
        emailLoading: false
      };
    case ADD_EXTRA_EMAIL_SUCCESS:
      return {
        ...state,
        emailLoading: false,
        eventInfo: {
          ...state?.eventInfo,
          extraContactEmails: action?.payload
        }
      };

    // remove extra emails
    case REMOVE_EXTRA_EMAIL_REQUEST:
      return {
        ...state,
        emailLoading: true
      };

    case REMOVE_EXTRA_EMAIL_FAILURE:
      return {
        ...state,
        emailLoading: false
      };

    case REMOVE_EXTRA_EMAIL_SUCCESS:
      return {
        ...state,
        emailLoading: false,
        eventInfo: {
          ...state?.eventInfo,
          extraContactEmails: action?.payload
        }
      };

    // update terms of position
    case "UPDATE_TERMS_OF_POSIITON": {
      const newData = action?.payload?.positionTerm;
      const updatedEventTerms = action?.payload?.eventTerm ?? {
        ...action?.payload?.eventTerms,
        ...state?.eventInfo?.terms
      };
      let newPositions = {};
      Object.keys(state?.positions)?.forEach((ses) => {
        state?.positions?.[ses]?.forEach((pos) => {
          if (
            !isArray(newPositions?.[ses]) ||
            isUndefined(newPositions?.[ses]?.length)
          ) {
            newPositions[ses] = [];
          }
          if (newData?.[pos?._id]) {
            newPositions[ses]?.push({
              ...pos,
              positionTerms: {
                ...(pos?.positionTerms || {}),
                ...(newData?.[pos?._id] || {})
              }
            });
          } else {
            newPositions[ses]?.push({ ...pos });
          }
        });
      });

      const updateIds = new Set(state?.timeUpdateIds);
      eHalfDay = false;
      Object.entries(newPositions).forEach(([key, positions]) => {
        newPositions[key] = positions?.map((pos) => {
          if (!eHalfDay && pos?.isHalfdayHours) {
            eHalfDay = true;
          }
          if (!newData?.[pos?._id]) {
            return pos;
          }
          const updatedPos = { ...pos };

          const isClientAndConDiff = isClientAndContractorInputDiffernet({
            pos,
            isCalifornia: state?.eventInfo?.terms?.californiaContractorPO_SOW
          });

          if (
            !pos?.contractorActualStart &&
            !isTimeTBD(pos?.timeIn) &&
            isClientAndConDiff
          ) {
            updatedPos.contractorActualStart = pos?.actualStart || pos?.timeIn;
            updateIds?.add(pos?._id);
          }
          if (
            !pos?.contractorActualEnd &&
            !isTimeTBD(pos?.timeOut) &&
            isClientAndConDiff
          ) {
            updatedPos.contractorActualEnd = pos?.actualEnd || pos?.timeOut;
            updateIds?.add(pos?._id);
          }

          if (true) {
            const isCalCase =
              state?.eventInfo?.terms?.californiaContractorPO_SOW;
            const estimateObj = getObjForPOCalculation({
              timezone: state?.eventInfo?.eventTimezone,
              pos: { ...pos, oT: null, actualMidnightOT: null, dT: null },
              terms: getFinalTerms({ eventTerms: updatedEventTerms }),
              appliedRate: checkValidValue({ value: pos?.estimateAppliedRate })
                ? pos?.estimateAppliedRate
                : pos?.positionData?.defaultRate,
              disableGivenOTDT: true
            });
            const { otHours, dtHours, overT } = calcEstimateForPO(estimateObj);

            updatedPos.oT = formatValue(otHours).toString();
            updatedPos.dT = formatValue(dtHours).toString();
            updatedPos.actualMidnightOT = formatValue(overT).toString();
          }

          if (isClientAndConDiff) {
            const isCalCase =
              state?.eventInfo?.terms?.californiaContractorPO_SOW;
            const estimateObj = getObjForPOCalculation({
              timezone: state?.eventInfo?.eventTimezone,
              pos,
              terms: getFinalTerms({ eventTerms: state?.eventInfo?.terms }),
              appliedRate: checkValidValue({ value: pos?.estimateAppliedRate })
                ? pos?.estimateAppliedRate
                : pos?.positionData?.defaultRate,
              isClient: false,
              isContractorDiff: true,
              disableGivenOTDT: true
            });
            const { otHours, dtHours, overT } = isCalCase
              ? calcEstimateForCaliforniaPO(estimateObj)
              : calcEstimateForPO(estimateObj);

            updatedPos.contractorOT = formatValue(otHours).toString();
            updatedPos.contractorDT = formatValue(dtHours).toString();
            updatedPos.contractorActualMidnightOT =
              formatValue(overT).toString();

            addContractorFirstBreak({ updatedPos, pos });
            addContractorSecondBreak({ updatedPos, pos });

            if (!updateIds?.has(pos?._id)) {
              updateIds.add(pos?._id);
            }
          }

          return updatedPos;
        });
      });

      return {
        ...state,
        positions: newPositions,
        estimatePositions: newPositions,
        eventHalfDay:
          state?.eventInfo?.terms?.clientHalfDayInc ||
          state?.eventInfo?.terms?.contractorHalfDayInc,
        timeUpdateIds: Array.from(updateIds),
        eventInfo: {
          ...state?.eventInfo,
          ...(updatedEventTerms ? { terms: updatedEventTerms } : {})
        }
      };
    }

    case "UPDATE_TERMS_OF_EVENT_AFTER_POSITION": {
      const updatedEventTerms = action?.payload?.eventTerm ?? {
        ...action?.payload?.eventTerms,
        ...state?.eventInfo?.terms
      };
      return {
        ...state,
        eventInfo: { ...state?.eventInfo, terms: updatedEventTerms },
        eventHalfDay:
          updatedEventTerms?.clientHalfDayInc ||
          updatedEventTerms?.contractorHalfDayInc
      };
    }

    // position terms update
    case POSITION_TERM_UPDATE_REQUEST:
      return {
        ...state,
        ptLoading: true
      };
    case POSITION_TERM_UPDATE_FAILURE:
      return {
        ...state,
        ptLoading: false
      };
    case POSITION_TERM_UPDATE_SUCCESS:
      return {
        ...state,
        ptLoading: false
      };

    // clear contractor different time
    case CLEAR_CONTRACTOR_DIFFERENT_TIME: {
      const pos = action?.payload;
      const newTimeUpdateIds = [...(state?.timeUpdateIds || [])];
      if (!newTimeUpdateIds?.includes(pos?._id)) {
        newTimeUpdateIds?.push(pos?._id);
      }
      return {
        ...state,
        timeUpdateIds: newTimeUpdateIds,
        positions: {
          ...state?.positions,
          [pos?.session?._id]: state?.positions?.[pos?.session?._id]?.map(
            (item) =>
              item?._id == pos?._id
                ? {
                    ...item,
                    contractorActualStart: null,
                    contractorActualEnd: null,
                    contractorFirstBreak: null,
                    contractorAfterFirstBreakIn: null,
                    contractorSecondBreak: null,
                    contractorAfterSecondBreakIn: null,
                    contractorOT: null,
                    contractorDT: null,
                    contractorActualMidnightOT: null,
                    contractorMealPenalty: null,
                    contractorMealPenaltyHours: null
                  }
                : item
          )
        }
      };
    }

    // unassign contractor from positions
    case UNASSIGN_CONTRACTOR_REQUEST:
      return {
        ...state,
        assignLoading: true,
        pLoading: true
      };
    case UNASSIGN_CONTRACTOR_FAILURE:
      return {
        ...state,
        assignLoading: false,
        pLoading: false
      };
    case UNASSIGN_CONTRACTOR_SUCCESS: {
      const removedIds = action?.payload?.Ids?.map((i) => i?.Id);
      let newPositions = {};
      for (const [sessionId, positions] of Object.entries(state?.positions)) {
        newPositions[sessionId] = positions?.map((item) => {
          if (removedIds?.includes(item?._id)) {
            return {
              ...item,
              assignedContractor: null,
              contractorName: null,
              preferredName: null
            };
          } else {
            return item;
          }
        });
      }
      return {
        ...state,
        assignLoading: false,
        pLoading: false,
        positions: newPositions
      };
    }

    // assign contractor tab
    case ASSIGN_COORDINATOR_META_DATA:
      return {
        ...state,
        tabData: {
          ...state?.tabData,
          assignContractorTab: {
            ...action?.payload
            // selectedSession: _.cloneDeep(action?.payload?.selectedSession),
          }
        }
      };

    // session management tab
    case SESSION_MANAGEMENT_META_DATA:
      return {
        ...state,
        tabData: {
          ...state?.tabData,
          sessionManagementTab: {
            ...action?.payload
            // selectedSession: _.cloneDeep(action?.payload?.selectedSession),
          }
        }
      };

    // update position's status after po status update
    case UPDATE_LOCAL_PO_STATUS_OF_POSITIONS: {
      let updatedPos = [];
      const newStatus = action?.payload?.poStatus;

      // Collect all position IDs to update
      action?.payload?.sessions?.forEach((ses) => {
        ses?.positions?.forEach((pos) => {
          updatedPos.push(pos?._id);
        });
      });

      // Clone positions deeply
      let newPositions = _.cloneDeep(state?.positions);

      // Iterate through each session
      Object.keys(newPositions)?.forEach((sessionId) => {
        newPositions[sessionId] = newPositions[sessionId]?.map((pos) => {
          if (updatedPos.includes(pos?._id)) {
            if (pos?.latestPODocId) {
              pos.latestPODocId.poStatus = newStatus;
            }
          }
          return pos;
        });
      });

      return {
        ...state,
        positions: newPositions
      };
    }

    // refresh rate list for event
    case REFRESH_RATE_LIST_FOR_EVENT_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    // add and update contractor and client applied rate
    case ADD_UPDATE_CLIENT_CONTRACTOR_RATE_REQUEST: {
      return {
        ...state,
        ...(action?.payload?.disableWholeLoader
          ? {}
          : {
              isLoading: true
            }),
        checkLoader: true,
        checkLoaderArr: [
          ...(state?.checkLoaderArr || []),
          ...(action?.payload?.Ids || [])
        ]
      };
    }

    case ADD_UPDATE_CLIENT_CONTRACTOR_RATE_FAILURE:
      return {
        ...state,
        ...(action?.payload?.disableWholeLoader
          ? {}
          : {
              isLoading: false
            }),
        checkLoader: false
      };

    case ADD_UPDATE_CLIENT_CONTRACTOR_RATE_SUCCESS: {
      const remainingCheckLoader = state?.checkLoaderArr?.filter(
        (a) => !action?.payload?.Ids?.includes(a)
      );
      const newPositions = {};
      if (action?.payload?.disableWholeLoader) {
        Object.entries(state?.positions).forEach(([key, val]) => {
          newPositions[key] = val?.map((pos) => {
            if (action?.payload?.Ids?.includes(pos?._id)) {
              return {
                ...pos,
                isClientDefaultRate: false,
                isContractorDefaultRate: false
              };
            } else return pos;
          });
        });
      }
      return {
        ...state,
        checkLoader: false,
        checkLoaderArr: remainingCheckLoader,
        ...(action?.payload?.disableWholeLoader
          ? {
              positions: newPositions
            }
          : {})
      };
    }

    // updatepo update needed key
    case UPDATE_PO_UPDATE_NEEDED_KEY: {
      let poUpdatesNeeded = false;
      const contractorId = action?.payload?.contractorId;
      let newPos = { ...(state?.positions || {}) };

      Object.entries(newPos)?.forEach(([key, positions]) => {
        newPos[key] = positions?.map((pos) => {
          if (pos?.assignedContractor == contractorId && pos?.isGeneratedPo) {
            const posData = { ...pos };
            posData.isShiftEditedAfterPOSent = true;
            poUpdatesNeeded = true;

            return posData;
          } else return pos;
        });
      });

      return {
        ...state,
        poUpdates: poUpdatesNeeded,
        positions: newPos
      };
    }

    // defualt case
    default:
      return state;
  }
};

export default eventRequestDetailsReducer;
export { initialState };
